import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
export function flattenTree(tree) {
  return tree.flatMap(function (item) {
    var children = item.children ? flattenTree(item.children) : [];
    return [item].concat(_toConsumableArray(children));
  });
}